import { Button } from 'react-bootstrap';

import { MapZoomButtonsProps } from 'root/widgets/mrt-search-modal/types';

const MapZoomButtons = ({ onZoomIn, onZoomOut }: MapZoomButtonsProps) => (
  <div className="map-zoom-buttons">
    <Button variant="secondary icon-square" onClick={onZoomIn}>
      <i className="pgicon-plus" />
    </Button>
    <Button variant="secondary icon-square" onClick={onZoomOut}>
      <i className="pgicon-minus" />
    </Button>
  </div>
);

MapZoomButtons.displayName = 'MapZoomButtons';

export default MapZoomButtons;
